<div class="flex items-center justify-center py-2 bg-grey-veryLight">
	Please enter your Stewart Title Credentials
</div>
<div class="flex flex-1">
	<div class="flex flex-col flex-1 w-full">
		<iframe
			id="stewart-oauth-iframe"
			[src]="iframeUrl"
			width="100%"
			height="100%"
			class="flex flex-1"
		></iframe>
	</div>
</div>
